import type { ReactNode } from 'react';
import styles from './checkbox-sub-groups.module.scss';
const CheckboxSubGroups = ({ children }: IProps) => {
	return <fieldset className={styles.wrapper}>{children}</fieldset>;
};

export default CheckboxSubGroups;

export interface IProps {
	children: ReactNode;
}
